import { render, staticRenderFns } from "./confirm_account.html?vue&type=template&id=70cab7fe&scoped=true&"
import script from "./confirm_account.js?vue&type=script&lang=js&"
export * from "./confirm_account.js?vue&type=script&lang=js&"
import style0 from "./confirm_account.scss?vue&type=style&index=0&id=70cab7fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cab7fe",
  null
  
)

export default component.exports